import { CurrencyCode } from "../../../Wrap/Constants/Enums/Domain/CurrencyCode";

export class CurrencySymbolDictionary {
    public static getSymbol(currencyCode: CurrencyCode) {
        if (CurrencySymbolDictionary.map == null) {
            CurrencySymbolDictionary.map = this.getMap();
        }

        if (CurrencySymbolDictionary.map.has(currencyCode)) {
            return CurrencySymbolDictionary.map.get(currencyCode);
        }

        throw new Error("Attempting to get currency symbol for unrecognized currency code");
    }
    private static map: Map<CurrencyCode, string>;

    public static getStringMap(code: CurrencyCode) {
        const map = {
            0:"NotSpecified",
            1:"ARS",
            2:"AMD" ,
            3:"AWG" ,
            4:"AUD" ,
            6:"BSD" ,
            7:"BHD" ,
            8:"BDT" ,
            9:"BBD" ,
            10:"BZD",
            11:"BMD",
            12:"BOB",
            13:"BAM",
            14:"BRL",
            15:"BND",
            16:"BGN",
            17:"CAD",
            18:"XPF",
            19:"CLP",
            20:"CNY",
            21:"COP",
            22:"CRC",
            23:"HRK",
            24:"CUP",
            26:"CZK",
            27:"DKK",
            28:"DOP",
            29:"XCD",
            30:"EGP",
            32:"EUR",
            33:"FKP",
            34:"FJD",
            38:"GHS",
            39:"GIP",
            40:"GBP",
            42:"GTQ",
            43:"HNL",
            44:"HKD",
            45:"HUF",
            46:"ISK",
            47:"INR",
            48:"IDR",
            50:"ILS",
            52:"JMD",
            53:"JPY",
            55:"JOD",
            56:"KES",
            57:"KWD",
            59:"LBP",
            60:"LTL",
            62:"MKD",
            63:"MYR",
            64:"MUR",
            65:"MXN",
            67:"MXV",
            69:"NPR",
            71:"ANG",
            72:"NZD",
            73:"NOK",
            74:"OMR",
            75:"PKR",
            76:"PEN",
            77:"PHP",
            78:"PLN",
            82:"SAR",
            83:"SGD",
            86:"SBD",
            87:"ZAR",
            88:"KRW",
            90:"LKR",
            91:"SEK",
            92:"CHF",
            93:"TWD",
            94:"TZS",
            95:"THB",
            96:"TOP",
            97:"TND",
            98:"TRY",
            99:"AED",
            100:"USD",
            101:"VUV",
            103:"VND",
            104:"WST",
            107:"PGK",
            108:"AFN",
            109:"DZD",
            110:"AZN",
            111:"PAB",
            112:"BYR",
            113:"VEF",
            114:"BIF",
            115:"CVE",
            116:"KYD",
            117:"XOF",
            118:"XAF",
            119:"KMF",
            120:"CDF",
            121:"NIO",
            122:"GMD",
            123:"DJF",
            124:"STD",
            125:"SVC",
            126:"ETB",
            128:"HTG",
            129:"PYG",
            130:"GNF",
            131:"GYD",
            132:"UAH",
            133:"IRR",
            134:"IQD",
            135:"LAK",
            136:"MWK",
            137:"AOA",
            138:"MMK",
            139:"GEL",
            140:"ALL",
            142:"SLL",
            143:"LRD",
            144:"LYD",
            145:"SZL",
            146:"LSL",
            147:"MGA",
            148:"MDL",
            149:"MAD",
            150:"MZN",
            151:"BOV",
            152:"NGN",
            153:"ERN",
            154:"NAD",
            155:"RON",
            156:"BTN",
            157:"KPW",
            158:"MRO",
            159:"MOP",
            160:"CUC",
            161:"UYU",
            162:"BWP",
            163:"QAR",
            164:"KHR",
            165:"MVR",
            166:"RUB",
            167:"RWF",
            168:"SHP",
            169:"RSD",
            170:"SCR",
            171:"KGS",
            172:"SOS",
            173:"TJS",
            174:"SSP",
            175:"SDG",
            176:"SRD",
            177:"SYP",
            178:"KZT",
            179:"TTD",
            180:"MNT",
            181:"TMT",
            182:"UGX",
            183:"CLF",
            184:"COU",
            185:"UYI",
            186:"UZS",
            187:"CHE",
            188:"CHW",
            189:"YER",
            190:"ZMW",
            191:"ZWL",
        }
        return map[code];
    }

    private static getMap(): Map<CurrencyCode, string> {
        const map = new Map<CurrencyCode, string>();

        map.set(CurrencyCode.EUR, "€");
        map.set(CurrencyCode.GBP, "£");
        map.set(CurrencyCode.CHF, "CHF");

        return map;
    }
}
